import script from "./new_payee.vue?vue&type=script&setup=true&lang=js"
export * from "./new_payee.vue?vue&type=script&setup=true&lang=js"

import "./new_payee.vue?vue&type=style&index=0&id=6897eba0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.member/src/fe-member/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6897eba0"]])

export default __exports__